import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import { STATUS_PAGE_URL } from "shared/Maintenance/constants";
import useMaintenanceStore from "shared/Maintenance/store";
import MaintenanceMessage from "components/MaintenanceMessage";

const MaintenanceCallout = () => {
  const enabled = useMaintenanceStore((state) => state.enabled);
  const message = useMaintenanceStore((state) => state.message);

  if (!enabled) return null;

  return (
    <Callout variant="warning" title="Maintenance in progress">
      <MaintenanceMessage>{message}</MaintenanceMessage>
      <FeedbackActions>
        <LinkButton
          variant="contrast"
          size="small"
          href={STATUS_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          View status page
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default MaintenanceCallout;
